// extracted by mini-css-extract-plugin
export default {"link":"style_link__ZpLE6","disabled":"style_disabled__5vGxD","s":"style_s__zSwwa","m":"style_m__oTF+A","l":"style_l__VjiXR"};